var emojis = [
	'👾','😺','😸','😹','😻','😼','😽','🙀','😿','😾','😺','😸','😹','😻','😼','😽','🙀','😿','😾'
];

function EmojiCat () {
  return emojis[Math.floor(Math.random() * emojis.length)];
}

export default EmojiCat;
